// extracted by mini-css-extract-plugin
export default {"root":"JkHGnHVpnO","root_active":"QA6pQUgpa_"};